/* tq-product · gallery + buy box.
   Nothing is pre-selected: the shopper picks each real option (hand, length),
   and the button says what is still missing. Single value options are filled
   in automatically. Adds to the real cart via /cart/add.js. */
(() => {
  const root = document.querySelector('[data-tq-pdp]');
  if (!root) return;

  /* ---- Gallery: scroll-snap strip, thumbs jump to a slide ---- */
  const slides = root.querySelector('[data-tq-slides]');
  const thumbs = [...root.querySelectorAll('[data-tq-thumb]')];
  const mark = (i) => thumbs.forEach((t, n) => t.toggleAttribute('aria-current', n === i));
  thumbs.forEach((t, i) => t.addEventListener('click', () => {
    slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
    mark(i);
  }));
  let raf;
  slides.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => mark(Math.round(slides.scrollLeft / slides.clientWidth)));
  }, { passive: true });

  /* ---- Variant picking ---- */
  const data = JSON.parse(root.querySelector('[data-tq-product]').textContent);
  const form = root.querySelector('[data-tq-form]');
  const idInput = root.querySelector('[data-tq-variant-input]');
  const priceEl = root.querySelector('[data-tq-price]');
  const addBtn = root.querySelector('[data-tq-add]');
  const addLabel = root.querySelector('[data-tq-add-label]');
  const msg = root.querySelector('[data-tq-msg]');
  const added = root.querySelector('[data-tq-added]');
  const addedWhat = root.querySelector('[data-tq-added-what]');
  const groups = [...root.querySelectorAll('[data-tq-option]')];

  // chosen[i] = value for option i (0 based); single value options fixed up front.
  const chosen = data.options.map((o) => (o.values.length === 1 ? o.values[0] : null));
  const groupFor = (i) => groups.find((g) => +g.dataset.tqOption === i + 1);

  // A link with ?variant= (ads, shared links) arrives pre-picked.
  const fromUrl = new URLSearchParams(location.search).get('variant') && data.variants.find((v) => v.id === data.urlVariant);
  if (fromUrl) fromUrl.options.forEach((val, i) => { chosen[i] = val; });

  // Some listings store "Right Hand"; show "Right" like the rest. The cart gets Shopify's exact value.
  const label = (s) => (s || '').replace(/ Hand$/, '');
  const match = () => data.variants.find((v) => v.options.every((val, i) => val === chosen[i]));

  function render() {
    groups.forEach((g) => {
      const i = +g.dataset.tqOption - 1;
      g.querySelector('[data-tq-option-val]').textContent = label(chosen[i]);
      g.querySelectorAll('input').forEach((inp) => {
        inp.checked = inp.value === chosen[i];
        // Grey out a value no in-stock variant can reach with the other picks.
        const reachable = data.variants.some((v) => v.available && v.options[i] === inp.value &&
          v.options.every((val, n) => n === i || !chosen[n] || val === chosen[n]));
        inp.closest('.tq-pdp__choice').classList.toggle('is-out', !reachable);
      });
      g.classList.remove('is-missing');
    });
    // In the order the groups appear on the page (hand first).
    const missing = groups.map((g) => +g.dataset.tqOption - 1).filter((i) => !chosen[i]).map((i) => data.options[i].name.toLowerCase());
    const v = missing.length ? null : match();
    idInput.value = v ? v.id : '';
    if (v) {
      // Holiday price (snippets/tq-promo.liquid): old price struck through, sale price beside it.
      if (v.sale) {
        priceEl.innerHTML = '';
        const was = document.createElement('span'); was.className = 'tq-was'; was.textContent = v.price;
        const now = document.createElement('span'); now.className = 'tq-now'; now.textContent = v.sale;
        priceEl.append(was, now);
      } else {
        priceEl.textContent = v.price;
      }
    }
    if (missing.length) {
      addLabel.textContent = 'Choose ' + missing.join(' and ');
    } else if (!v || !v.available) {
      addLabel.textContent = 'Sold out';
    } else {
      addLabel.textContent = 'Add to cart · ' + (v.sale || v.price);
    }
    addBtn.classList.toggle('is-ready', !!(v && v.available));
    if (v && history.replaceState) {
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }
  }

  groups.forEach((g) => g.addEventListener('change', (e) => {
    chosen[+g.dataset.tqOption - 1] = e.target.value;
    msg.textContent = '';
    added.hidden = true;
    render();
  }));

  /* ---- Add to cart ---- */
  addBtn.addEventListener('click', async () => {
    const firstMissing = groups.map((g) => +g.dataset.tqOption - 1).find((i) => !chosen[i]);
    if (firstMissing !== undefined) {
      const g = groupFor(firstMissing);
      g.classList.add('is-missing');
      g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      msg.textContent = 'Choose your ' + data.options[firstMissing].name.toLowerCase() + ' first.';
      return;
    }
    const v = match();
    if (!v || !v.available) return;
    addBtn.disabled = true;
    addLabel.textContent = 'Adding…';
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
      });
      const out = await r.json();
      if (!r.ok) throw new Error(out.description || out.message || 'Could not add to cart.');
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('.tq-header__count').forEach((c) => { c.textContent = cart.item_count; c.hidden = !cart.item_count; });
      addedWhat.textContent = groups.map((g) => {
        const i = +g.dataset.tqOption - 1; const n = data.options[i].name;
        return n === 'Hand' ? label(chosen[i]) + ' hand' : chosen[i];
      }).join(', ') + '.';
      if (!groups.length) addedWhat.textContent = (data.title || '') + '.';
      added.hidden = false;
      msg.textContent = '';
    } catch (err) {
      msg.textContent = err.message + ' Please try again, or call 716 667 9215.';
    } finally {
      addBtn.disabled = false;
      render();
    }
  });

  render();
})();
